import { CallbackTypes, DropInPaymentsCommandNames, OneClickCommandNames, StatusTypes } from './CallbackUtils/constants';
// all possible commands trigger when a order is placed
export var PlacedOrdersCommands = [DropInPaymentsCommandNames.PLACE_ORDER, DropInPaymentsCommandNames.PLACE_ORDER_THROUGH_SDK, OneClickCommandNames.RESUME_ORDER, OneClickCommandNames.RESTART_ORDER];

/**
 * Helper function that checks if an order is placed and returns the order.
 * See list of status update by 1-click checkout -
 * https://chegg.atlassian.net/wiki/spaces/GMG/pages/568593390/DCO+1-Click#List-of-Status-Updates-Fired-by-1-Click
 * @param oneClickCallbackPayload
 * @returns GetCheckoutOrderStatus
 */
var getPlacedCheckoutOrder = function getPlacedCheckoutOrder(oneClickCallbackPayload) {
  var data = oneClickCallbackPayload.data,
    callbackType = oneClickCallbackPayload.callbackType;
  if (callbackType == CallbackTypes.STATUS_UPDATE) {
    var placedOrder = data.find(function (status) {
      return PlacedOrdersCommands.includes(status.command) && (status.status === StatusTypes.SUCCESS || status.status === StatusTypes.ERROR);
    });
    return placedOrder;
  }
  return undefined;
};
export default getPlacedCheckoutOrder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getPlacedCheckoutOrder.js
// module id = 4124
// module chunks = 11